const Scroll = {
    init() {
        this.initScrollObserver();
    },

    createObserverTarget() {
        const target = document.createElement('div');
        target.style.position = 'absolute';
        target.style.top = '0';
        target.style.height = '1px';
        target.style.width = '100%';
        document.body.appendChild(target);
        return target;
    },

    initScrollObserver() {
        const target = this.createObserverTarget();
        
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    document.body.classList.remove('not-at-top');
                } else {
                    document.body.classList.add('not-at-top');
                }
            });
        }, {
            root: null, // viewport
            rootMargin: '0px',
            threshold: 0
        });

        observer.observe(target);
    }
};

export default Scroll; 